/**
 * Where the account page's legal rows point, and who its support mail reaches.
 *
 * Placeholders on the MENU! domain. The backend carries no legal links and no
 * support address: the venue's mobile-app branding exposes only a name and a
 * website, so there is nothing per restaurant to read these from. Swap them
 * for the real addresses before this ships.
 */
export const PRIVACY_POLICY_URL = "https://menupos.pl/polityka-prywatnosci";

export const TERMS_URL = "https://menupos.pl/regulamin";

export const SUPPORT_EMAIL = "support@menupos.pl";

/**
 * A mail the guest only has to add their question to.
 *
 * The venue and table travel in the body because support cannot look a guest
 * up: there is no account, and the points live in the phone.
 */
export const supportMailtoUrl = (subject: string, body: string): string =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(body)}`;
